import "../../../style/VideoGeneralPage/VideoGeneralPage.css"
import {useState, useEffect} from 'react';
import {useStore} from 'effector-react';
import {Modal} from '../../../../common/UI/Modal/molecules/Modal';
import {NavMenu} from "../../../../common/UI/NavMenu/organoids/NavMenu"
import {
    $GuideMode,
    $ReadenVideoSlides,
    AddReadenVideoSlide,
    setOpenModel
} from '../../../../common/UI/GuideButtons/logic/GuideLogic';
import {GuideButtons} from '../../../../common/UI/GuideButtons/organoids/GuideButtons';
import {IForModal, Ipoint2D} from '../../../../common/interfaces';
import {titleName} from '../../../../common/function';
import { useTranslation } from 'react-i18next';

import VIDEO from '../../../../common/assets/videos/model.mp4';

export const VideoPagePWA = () => {
    const { t } = useTranslation()
    const videoPoints: Ipoint2D[] = [
        {
          id: 1,
          top: "0.5rem",
          left: "54%",
          title: t('VideoPage.VideoPage_1.Title'),
          titletext:[""],
          title_short: t('VideoPage.VideoPage_1.Short_Title')!,
          content: [""],
          text: [""],
          list: [
            {
              title: "",
              quotes: [
                t('VideoPage.VideoPage_1.Quotes_1'),
                t('VideoPage.VideoPage_1.Quotes_2'),
                t('VideoPage.VideoPage_1.Quotes_3'),
                t('VideoPage.VideoPage_1.Quotes_4'),
                t('VideoPage.VideoPage_1.Quotes_5'),
                t('VideoPage.VideoPage_1.Quotes_6'),
                t('VideoPage.VideoPage_1.Quotes_7'),
                t('VideoPage.VideoPage_1.Quotes_8'),
                t('VideoPage.VideoPage_1.Quotes_9'),
              ],
            },
          ],
        },
        {
          id: 2,
          top: "0.5rem",
          left: "47%",
          titletext:[""],
          title: t('VideoPage.VideoPage_2.Title'),
          title_short: t('VideoPage.VideoPage_2.Short_Title')!,
          content: [t('VideoPage.VideoPage_2.Picture')],
          text: [""],
        },
        {
          id: 3,
          top: "0.5rem",
          left: "47%",
          titletext:[""],
          title: t('VideoPage.VideoPage_3.Title'),
          title_short: t('VideoPage.VideoPage_3.Short_Title')!,
          minWidthTable:"40vw",
          maxWidthTable:"40vw",
          content: [""],
          text: [""],
          table: {
            tableheads: [
              { width: "33%", content: t('VideoPage.VideoPage_3.Table.tableheads.content1') },
              { width: "33%", content: t('VideoPage.VideoPage_3.Table.tableheads.content2') },
              { width: "33%", content: t('VideoPage.VideoPage_3.Table.tableheads.content3') },
            ],
            rows: [
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_3.Table.rows.rows1.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_3.Table.rows.rows1.content1')]},
                    {content:[t('VideoPage.VideoPage_3.Table.rows.rows1.content2')]},
                    {content:[t('VideoPage.VideoPage_3.Table.rows.rows1.content3')]}
                    ,
                  ],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_3.Table.rows.rows2.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_3.Table.rows.rows2.content1')]},
                    {content:[t('VideoPage.VideoPage_3.Table.rows.rows2.content2')]},
                    {content:[t('VideoPage.VideoPage_3.Table.rows.rows2.content3')]},
                  ],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_3.Table.rows.rows3.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_3.Table.rows.rows3.content1')]},
                    {content:[t('VideoPage.VideoPage_3.Table.rows.rows3.content2')]},
                    {content:[t('VideoPage.VideoPage_3.Table.rows.rows3.content3')]},
                   
                  ],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_3.Table.rows.rows4.title'),
                showhead: true,
                columns: [
                  [
                    {content:[ t('VideoPage.VideoPage_3.Table.rows.rows4.content1')]},
                    {content:[ t('VideoPage.VideoPage_3.Table.rows.rows4.content2')]},
                    {content:[ t('VideoPage.VideoPage_3.Table.rows.rows4.content3')]},
              
                  ],
                ],
              },
            ],
          },
        },
        {
          id: 4,
          top: "0.5rem",
          left: "54%",
          titletext:[""],
          title: t('VideoPage.VideoPage_4.Title'),
          title_short: t('VideoPage.VideoPage_4.Short_Title')!,
          content: [t('VideoPage.VideoPage_4.Picture')],
          text: [""],
        },
        {
          id: 5,
          top: "0.5rem",
          left: "54%",
          titletext:[""],
          minWidthTable:"30vw",
          maxWidthTable:"30vw",
          title: t('VideoPage.VideoPage_5.Title'),
          title_short: t('VideoPage.VideoPage_5.Short_Title')!,
          content: [t('VideoPage.VideoPage_5.Picture')],
          text: [""],
        },
        {
          id: 6,
          top: "0.5rem",
          left: "54%",
          titletext:[""],
          title: t('VideoPage.VideoPage_6.Title'),
          title_short: t('VideoPage.VideoPage_6.Short_Title')!,
          content: [""],
          text: [""],
          minWidthTable:"40vw",
          maxWidthTable:"40vw",
          table: {
            tableheads: [
              { width: "50%", content:t('VideoPage.VideoPage_6.Table.tableheads.content1') },
              { width: "50%", content: t('VideoPage.VideoPage_6.Table.tableheads.content2') },
            ],
            rows: [
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_6.Table.rows.rows1.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows1.content1')],minWidth:["10vw"]},
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows1.content2')],minWidth:["10vw"]},
                    
                    
                  ],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_6.Table.rows.rows2.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows2.content1')],minWidth:["10vw"]},
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows2.content2')],minWidth:["10vw"]},
                  ],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_6.Table.rows.rows3.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows3.content1')],minWidth:["10vw"]},
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows3.content2')],minWidth:["10vw"]},
                  ],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_6.Table.rows.rows4.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows4.content1')],minWidth:["10vw"]},
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows4.content2')],minWidth:["10vw"]},
                    
                    
                  ],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_6.Table.rows.rows5.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows5.content1')],minWidth:["10vw"]},
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows5.content2')],minWidth:["10vw"]},
                  ],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_6.Table.rows.rows6.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows6.content1')],minWidth:["10vw"]},
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows6.content2')],minWidth:["10vw"]},
                  ],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_6.Table.rows.rows7.title'),
                showhead: true,
                columns: [
                  [
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows7.content1')],minWidth:["10vw"]},
                    {content:[t('VideoPage.VideoPage_6.Table.rows.rows7.content2')],minWidth:["10vw"]},
                  ],
                ],
              },
            ],
          },
        },
        {
          id: 7,
          top: "0.5rem",
          left: "47%",
          titletext:[""],
          title: t('VideoPage.VideoPage_7.Title'),
          title_short: t('VideoPage.VideoPage_7.Short_Title')!,
          minWidthTable:"40vw",
          maxWidthTable:"40vw",

          content: [""],
          text: [""],
          table: {
            tableheads: [
              { width: "25%", content: t('VideoPage.VideoPage_7.Table.tableheads.content1') },
              { width: "25%", content: t('VideoPage.VideoPage_7.Table.tableheads.content2')},
              { width: "25%", content: t('VideoPage.VideoPage_7.Table.tableheads.content3') },
              { width: "25%", content: t('VideoPage.VideoPage_7.Table.tableheads.content4') },
            ],
            rows: [
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_7.Table.rows.rows1.title'),
                
                showhead: false,
                columns: [
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns1.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns1.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns1.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns2.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns2.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns2.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns3.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns3.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns3.content3')]}],
                
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns4.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns4.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns4.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns5.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns5.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns5.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns6.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns6.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns6.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns7.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns7.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns7.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns8.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns8.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns8.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns9.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns9.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns9.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns10.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns10.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns10.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns11.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns11.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns11.content3')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns12.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns12.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns12.content3')]}],

                  
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns13.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns13.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns13.content3')]}],

                  
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns14.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns14.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns14.content3')]}],

                  
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns15.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns15.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows1.columns15.content3')]}],
      
      
      
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_7.Table.rows.rows2.title'),
                showhead: false,
                columns: [
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns1.content1')],minWidth:["15vw"]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns1.content2')],minWidth:["15vw"]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns2.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns2.content2')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns3.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns3.content2')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns4.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns4.content2')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns5.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns5.content2')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns6.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows2.columns6.content2')]}],
      
      
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_7.Table.rows.rows3.title'),
                showhead: true,
                columns: [
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows3.columns1.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows3.columns1.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows3.columns1.content3')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows3.columns1.content4')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows3.columns2.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows3.columns2.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows3.columns2.content3')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows3.columns2.content4')]}],
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_7.Table.rows.rows4.title'),
                showhead: true,
                columns: [
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows4.columns1.content1')]},
                  {content:[ t('VideoPage.VideoPage_7.Table.rows.rows4.columns1.content2')]},
                  {content:[ t('VideoPage.VideoPage_7.Table.rows.rows4.columns1.content3')]},
                  {content:[ t('VideoPage.VideoPage_7.Table.rows.rows4.columns1.content4')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows4.columns2.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows4.columns2.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows4.columns2.content3')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows4.columns2.content4')]}],
      
                ],
              },
              {
                tableText:[""],
                tableContent:[""],
                title: t('VideoPage.VideoPage_7.Table.rows.rows5.title'),
                showhead: true,
                columns: [
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns1.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns1.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns1.content3')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns1.content4')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns2.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns2.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns2.content3')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns2.content4')]}],
      
                  [{content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns3.content1')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns3.content2')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns3.content3')]},
                  {content:[t('VideoPage.VideoPage_7.Table.rows.rows5.columns3.content4')]}],
      
                ],
              },
            ],
          },
        },
      ];
    const [modalActive, setmodalActive] = useState(false)
    const [forModal, setForModal] = useState<IForModal>({
        title: '',
        content: [""],
        text: [''],
        minWidthTable:'',
        maxWidthTable:'',
        table: {
            tableheads: [{width: '', content: ''}],
            rows: [{title: '', showhead: true, columns: [], tableContent: [], tableText: []}]
        }
    })
    const [spreadMenu, setSpreadMenu] = useState<boolean>(false)
    const points = videoPoints;
    const readenVideoSlides = useStore($ReadenVideoSlides)

    titleName(t('BrowserLine.VideoPage'))

    useEffect(() => {
        if ($GuideMode.getState()) {
            if (readenVideoSlides === points.length) {
                setOpenModel(true)
            }
        }
    }, [readenVideoSlides, points.length])

    return (
        <div className='VideoPage'>
            <div className="Page_BlockTitle">{t('VideoPage.Title')}</div>
            <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'row', flex: 1, width: "100%"}}>
                <video src={VIDEO} className="videblock" loop controls autoPlay muted
                       style={spreadMenu ? {
                               // transform: "translate(-20%, 0)",
                               transition: '0.5s'
                           }
                           : {transition: '0.5s'}}/>
                <GuideButtons spreadMenu={spreadMenu}
                              setSpreadMenu={setSpreadMenu}
                              ReadenMarkers={readenVideoSlides}
                              AddReadenMarker={AddReadenVideoSlide}
                              markers={points}
                              setForModal={setForModal}
                              setModalActive={setmodalActive}/>
                <Modal image={[forModal.content[0]]} active={modalActive} setHover={setmodalActive} points={null}
                       list={forModal.list} title={forModal.title} table={forModal.table} minWidthTable={forModal.minWidthTable} maxWidthTable={forModal.maxWidthTable}/>
            </div>
            <NavMenu nextUrl={"/pwa/model"} backUrl={"/pwa/photo"} visibleFlag={"/pwa/video"}/>
        </div>
    )
} 